import styled from 'styled-components'

export const DefaultButton = styled.button`
  @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
    width: 100%;
    min-width: auto;
  }

  ${ ({ className }) =>
    className.includes('btn-link') &&
    `
        color: #000;
    ` }

  ${ ({ className }) =>
    className.includes('btn-moreFilters') &&
    `
        background-color: transparent;
        text-decoration: underline;
        position: relative;
        display: block;
        min-width: auto;
        padding: 10px;
        border: none;
        &:after {
            position: relative;
            bottom: 2px;
            font: normal normal normal 16px "aok-icons-functional";
            margin-left: 15px;
            transition: .3s transform ease-out;
            transform-origin: center center;
            display: inline-block;
            line-height: 1;
            text-rendering: auto;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            transform: translate(0, 0);
            content: "";
            vertical-align: middle;
        }
        &:hover, &:active, &:focus, :active:focus {
            box-shadow: none;
            padding: 10px;
            background-color: transparent;
            text-decoration: underline;
            border: none;
            &:after {
                transform: rotate(90deg)
            }
        }
    ` }

    span[class*='icon-'] {
    padding: 0 10px;
  }

  ${ (props) =>
    props.className.includes('with-border') &&
    `
        border-color: ${ props.theme.colors['icon-grau3'] };
        margin: 30px 0 0 20px;

        span[class*='icon']::before {
            color: ${ props.theme.colors['icon-grau3'] };
            font-size: 24px;
            position: relative;
            top: -3px;
        }
    ` }
`
